// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3z1ZL","large":"styles_large__1Lpgk"};